import React, { useRef, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useEditorActions, useSelectedId } from '../../store/editorStore.jsx';

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }, { background: [] }],
    ['code-block', 'blockquote'],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'color', 'background',
  'code-block', 'blockquote', 'link',
];

export function TextCanvas({ block }) {
  const selectedId = useSelectedId();
  const { updateAttrs, selectBlock } = useEditorActions();
  const isSelected = selectedId === block.id;
  const [localHtml, setLocalHtml] = useState(block.attrs.html || '');
  const quillRef = useRef(null);

  // Keep local state in sync when block changes from outside
  useEffect(() => {
    setLocalHtml(block.attrs.html || '');
  }, [block.attrs.html]);

  const handleBlur = () => {
    if (localHtml !== block.attrs.html) {
      updateAttrs(block.id, { html: localHtml });
    }
  };

  if (!isSelected) {
    return (
      <div
        className="editor-text-preview px-2 py-1"
        style={{ minHeight: 40, cursor: 'text', lineHeight: 1.7 }}
        onClick={() => selectBlock(block.id)}
        dangerouslySetInnerHTML={{ __html: block.attrs.html || '<p class="text-muted">Click to add text…</p>' }}
      />
    );
  }

  return (
    <div className="editor-text-editor" onClick={(e) => e.stopPropagation()}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={localHtml}
        onChange={setLocalHtml}
        onBlur={handleBlur}
        modules={quillModules}
        formats={quillFormats}
        style={{ backgroundColor: 'white' }}
      />
    </div>
  );
}

export function TextInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">CSS Class</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={block.attrs.className || ''}
          onChange={(e) => updateAttrs(block.id, { className: e.target.value })}
          placeholder="optional-extra-class"
        />
      </div>
    </div>
  );
}
